import Icon from '@mdi/react'
import styled from 'styled-components'

import theme from 'theme_'

export const StyledJobFolderIcon = styled(Icon)`
  vertical-align: middle;
  margin-right: 14px;
  color: ${theme.colors.beachGrey};
`
